<content>
    <section class="entry-inline-framed">
        <label>{{'gestionLicencias.parametros.licencia' | translate}}</label> {{licenciaId}}
        <label>{{'gestionLicencias.parametros.usuario' | translate}}</label> {{userName}}
    </section>
    <section class="filters-framed">
    <form [formGroup]="paramForm" [ngClass]="{'show-error':showError}" *ngIf="!licenciaJunta">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <div class="entry-4-modal">
              <label>{{'global.pais' | translate}} *</label>
              <app-filterable-list [itemsList]="paises" [selectedItem]="paramForm.get('pais')"
                    [placeHolder]="false"></app-filterable-list>
            </div>
        <div class="entry-4-modal">
            <label>{{'gestionLicencias.parametros.form.denominacion' | translate}} *</label>
            <app-filterable-list [itemsList]="denominaciones" [selectedItem]="paramForm.get('denominacion')" [placeHolder]="false" [disabled]="disabledDenominaciones"></app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'gestionLicencias.parametros.form.etiquetador' | translate}} *</label>
            <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="paramForm.get('etiquetador')"
                [disabled]="disabledEtiquetadores" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'global.almacen' | translate}} *</label>
            <app-filterable-list [itemsList]="almacenes" [selectedItem]="paramForm.get('almacen')"
                [disabled]="disabledAlmacenes" [placeHolder]="false"></app-filterable-list>
        </div>
    </form>
    </section>
    <footer class="button-bar-right" *ngIf="!licenciaJunta">
        <button (click)="add()">{{'global.insertar' | translate}}</button>
    </footer>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="icon"></th>
                        <th class="string">{{'global.pais' | translate}}</th>
                        <th class="string">{{'gestionLicencias.parametros.table.etiquetador' | translate}}</th>
                        <th class="string">{{'gestionLicencias.parametros.table.denominacion' | translate}}</th>
                        <th class="string">{{'global.almacen' | translate}}</th>
                        <th>{{'gestionLicencias.parametros.table.fecha' | translate}}</th>
                        <th class="string">{{'gestionLicencias.parametros.table.acciones' | translate}}</th>
                    </tr>
                </thead>
                <tbody *ngFor="let param of licenciaParamsPaginada; let i=index; trackBy: trackByParam">
                    <tr>    
                        <td class="icon">
                            <i class="fas fa-pen-nib" *ngIf="param.modoCertificado" title="{{'global.modoCertificado' | translate}}" app-click-stop-propagation></i>
                        </td>
                        <td class="string">{{param.desPaisTraduccion ?? param.desPais}}</td>
                        <td class="string">{{param.desEtiquetador}}</td>
                        <td class="string">{{param.desDenominacion}}</td>
                        <td class="string">{{param.desAlmacen}}</td>
                        <td>{{param.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="multi-actions">
                            <i class="fas fa-stream" app-click-stop-propagation (click)="openTabs(i)" title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                            <i class="far fa-trash-alt" [ngClass]="{'disabled': !(role === 'Administrador' || role === 'Soporte')}"
                                (click)="askDelete(param)" title="{{'titles.eliminar' | translate}}"></i>
                        </td>
                    </tr>
                    <tr *ngIf="dropdownSection === i">
                        <td colspan="7">
                            <section class="tabs">
                                <ul>
                                    <li [ngClass]="{'active': pestanaActiva[i] === 1}" (click)="showGrupoEtiquetaDenominacion(i)">{{'gestionLicencias.parametros.table.tabs.grupoEtiquetasDeno.titulo' | translate}}</li>
                                    <li [ngClass]="{'active': pestanaActiva[i] === 2}" (click)="showGrupoEtiquetaMarca(i)">{{'gestionLicencias.parametros.table.tabs.grupoEtiquetasMarca.titulo' | translate}}</li>
                                    <li [ngClass]="{'active': pestanaActiva[i] === 3}" (click)="showCertificado(i)">{{'gestionLicencias.parametros.table.tabs.certificado.titulo' | translate}}</li>
                                </ul>
                                <content>
                                    <app-param-grupo-etiquetas-denominacion *ngIf="pestanaActiva[i] === 1" [grupoEtiquetas]="param" (refresh)="toRefresh($event)" (pushMessage)="pushMessage($event)"></app-param-grupo-etiquetas-denominacion>
                                    <app-param-grupo-etiquetas-marca *ngIf="pestanaActiva[i] === 2" [grupoEtiquetas]="param" (refresh)="toRefresh($event)" (pushMessage)="pushMessage($event)"></app-param-grupo-etiquetas-marca>
                                    <app-params-certificado *ngIf="pestanaActiva[i] === 3" [certificados]="param" (refresh)="toRefresh($event)" (pushMessage)="pushMessage($event)"></app-params-certificado>
                                </content>
                            </section>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="7">
                            <app-paginator
                                *ngIf="(licenciaParams && licenciaParams.length > 0)"
                                [itemsPerPage]="itemsPerPage" [currentPage]="currentPage+1" [totalItems]="totalItems"
                                [visiblePages]="visiblePages" [hiddeItems]="hiddeItems" (pageChange)="pageChange($event)">
                            </app-paginator>
                        </td>
                    </tr>
                    <tr *ngIf="!licenciaParams || (licenciaParams && licenciaParams.length < 1)">
                        <td colspan="7">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</content>
<footer class="button-bar-right">
    <button (click)="close()">{{'global.aceptar' | translate}}</button>
</footer>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="closeDeleteModal()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
